import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HomePageActions } from "../Store/Home/action";

function MarqueeText() {
  const dispatch = useDispatch();
  const { HeaderScrollText } = useSelector((state) => state.HomePageReducer);

  const marqueeContentRef = useRef(null);
  const [animationDuration, setAnimationDuration] = useState("20s");

  useEffect(() => {
    dispatch({ type: HomePageActions.GET_HOME_TOPBAR_SCROLL_TEXT });
  }, [dispatch]);

  useEffect(() => {
    if (marqueeContentRef.current) {
      const contentWidth = marqueeContentRef.current.scrollWidth;
      const containerWidth =
        marqueeContentRef.current.parentElement.offsetWidth;

      const scrollSpeed = 100;
      const duration = (contentWidth + containerWidth) / scrollSpeed;

      setAnimationDuration(`${duration}s`);
    }
  }, [HeaderScrollText]);

  const handleMouseEnter = () => {
    if (marqueeContentRef.current) {
      marqueeContentRef.current.style.animationPlayState = "paused";
    }
  };

  const handleMouseLeave = () => {
    if (marqueeContentRef.current) {
      marqueeContentRef.current.style.animationPlayState = "running";
    }
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      <div className="text-wrapper-marque col-md-9">
        <div
          className="marquee-scroll"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div
            className="marquee-content"
            ref={marqueeContentRef}
            style={{
              animationDuration: animationDuration,
              animationName: "marquee-scroll",
              animationTimingFunction: "linear",
              animationIterationCount: "infinite",
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            {HeaderScrollText.map((item, index) => (
              <span key={index} className="marquee-scroll-item">
                <span style={{ marginRight: "5px" }}>{item.title}</span>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  {item.link_text}
                </a>
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="code-wrap col-md-3 text-right">
        <p className="static-text">
          <a
            href="https://ethosfoundation.in/web/arcause/club-details/psginstitute687/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            Auresca
          </a>{" "}
          | TNEA Counselling code: <span>2379</span>
        </p>
      </div>
    </div>
  );
}

export default MarqueeText;
